import React from "react";

const Features = () => {
  const features = [
    {
      icon: "fas fa-bolt",
      title: "Lightning Fast",
      description:
        "SSD storage and optimized configurations ensure your applications run at peak performance.",
      color: "warning",
    },
    {
      icon: "fas fa-shield-alt",
      title: "Enterprise Security",
      description:
        "Advanced firewalls, DDoS protection, and regular security updates keep your data safe.",
      color: "success",
    },
    {
      icon: "fas fa-chart-line",
      title: "Auto Scaling",
      description:
        "Automatically scale resources up or down based on demand to optimize costs.",
      color: "info",
    },
    {
      icon: "fas fa-headset",
      title: "24/7 Support",
      description:
        "Expert technical support available around the clock to help you succeed.",
      color: "primary",
    },
    {
      icon: "fas fa-database",
      title: "Reliable Backups",
      description:
        "Automated daily backups with one-click restore functionality.",
      color: "secondary",
    },
    {
      icon: "fas fa-globe",
      title: "Global CDN",
      description:
        "Worldwide content delivery network for faster loading times globally.",
      color: "danger",
    },
  ];

  const plans = [
    {
      name: "Starter",
      price: "$9.99",
      features: [
        "1 CPU Core",
        "2GB RAM",
        "50GB SSD",
        "1TB Bandwidth",
        "Basic Support",
      ],
      popular: false,
    },
    {
      name: "Professional",
      price: "$29.99",
      features: [
        "4 CPU Cores",
        "8GB RAM",
        "200GB SSD",
        "5TB Bandwidth",
        "Priority Support",
      ],
      popular: true,
    },
    {
      name: "Enterprise",
      price: "$99.99",
      features: [
        "8 CPU Cores",
        "32GB RAM",
        "1TB SSD",
        "Unlimited Bandwidth",
        "24/7 Dedicated Support",
      ],
      popular: false,
    },
  ];

  return (
    <>
      {/* Features Section */}
      <section id="features" className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold">Why Choose ServerPro?</h2>
            <p className="lead text-muted">
              Powerful features designed to accelerate your business growth
            </p>
          </div>

          <div className="row g-4">
            {features.map((feature, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body text-center p-4">
                    <div
                      className={`bg-${feature.color} bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3`}
                      style={{ width: "80px", height: "80px" }}
                    >
                      <i
                        className={`${feature.icon} fa-2x text-${feature.color}`}
                      ></i>
                    </div>
                    <h5 className="card-title fw-bold">{feature.title}</h5>
                    <p className="card-text text-muted">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold">Simple, Transparent Pricing</h2>
            <p className="lead text-muted">
              Choose the perfect plan for your needs
            </p>
          </div>

          <div className="row g-4 justify-content-center">
            {plans.map((plan, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div
                  className={`card h-100 ${
                    plan.popular
                      ? "border-primary shadow-lg"
                      : "border-0 shadow-sm"
                  }`}
                >
                  {plan.popular && (
                    <div className="card-header bg-primary text-white text-center py-2">
                      <small className="fw-bold">MOST POPULAR</small>
                    </div>
                  )}
                  <div className="card-body text-center p-4">
                    <h5 className="card-title fw-bold">{plan.name}</h5>
                    <div className="mb-4">
                      <span className="display-4 fw-bold">{plan.price}</span>
                      <span className="text-muted">/month</span>
                    </div>
                    <ul className="list-unstyled mb-4">
                      {plan.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="mb-2">
                          <i className="fas fa-check text-success me-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <button
                      className={`btn ${
                        plan.popular ? "btn-primary" : "btn-outline-primary"
                      } w-100`}
                    >
                      Get Started
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Features;
